import { type FC, useState } from "react"
import { SharedText } from "@/components/SharedText/SharedText"
import { useAppSelector } from "@/hooks/redux"
import { Button } from "@/ui/Button/Button"
import { HOST_NAME_COOKIE_KEY, ROUTES } from "@/utils/constants"
import { cookies } from "@/utils/common/helpers"

type ShareListButtonPropsType = {
  categoryUid: string
}

export const ShareListButton: FC<ShareListButtonPropsType> = ({
  categoryUid,
}) => {
  const [isShow, setIsShow] = useState(false)
  const host = cookies.get(HOST_NAME_COOKIE_KEY)
  const groupName = useAppSelector((state) => {
    const { groups } = state.favorites
    const group = !!groups
      ? groups.find((g) => g.uid === categoryUid)
      : undefined

    if (group) {
      return group.name
    } else {
      return "Список избранного"
    }
  })

  return (
    <Button
      isClean
      variant={"link"}
      icon={"Share"}
      onClick={() => setIsShow(true)}
    >
      Поделиться списком
      <SharedText
        isShowed={isShow}
        setIsShowed={setIsShow}
        share={{
          url: `https://${host}${ROUTES.favorites}${ROUTES.shared}/${categoryUid}`,
          title: groupName,
        }}
      />
    </Button>
  )
}
